import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Faq = lazy(() => import('../../views/pages/faq'))
const ApiKey = lazy(() => import('../../views/pages/api-key'))
const Profile = lazy(() => import('../../views/pages/profile'))
const Pricing = lazy(() => import('../../views/pages/pricing'))
const License = lazy(() => import('../../views/pages/license'))
const Error = lazy(() => import('../../views/pages/misc/Error'))
const WikiList = lazy(() => import('../../views/pages/wiki/list'))
const WikiEdit = lazy(() => import('../../views/pages/wiki/edit'))
const WikiDetails = lazy(() => import('../../views/pages/wiki/details'))
const ComingSoon = lazy(() => import('../../views/pages/misc/ComingSoon'))
const ModalExamples = lazy(() => import('../../views/pages/modal-examples'))
const Maintenance = lazy(() => import('../../views/pages/misc/Maintenance'))
const AccountSettings = lazy(() => import('../../views/pages/account-settings'))
const ClockInOut = lazy(() => import('../../views/pages/daily-planning'))
const MyTimeSheet = lazy(() => import('../../views/pages/daily-planning/MyTimeSheet'))
const ResourcePlanning = lazy(() => import('../../views/pages/resource-planning/list'))
const NotAuthorized = lazy(() => import('../../views/pages/misc/NotAuthorized'))
const KnowledgeBase = lazy(() => import('../../views/pages/knowledge-base/KnowledgeBase'))
const KnowledgeBaseCategory = lazy(() => import('../../views/pages/knowledge-base/KnowledgeBaseCategory'))
const KBCategoryQuestion = lazy(() => import('../../views/pages/knowledge-base/KnowledgeBaseCategoryQuestion'))
const BookTimeOff = lazy(() => import('../../views/pages/book-time-off/list'))
const ZendeskTickets = lazy(() => import('../../views/pages/zendesk-tickets'))
const SystemSwitch = lazy(() => import('../../views/pages/system-switch'))

const PagesRoutes = [
  {
    path: '/pages/profile',
    element: <Profile />
  },
  {
    path: '/pages/faq',
    element: <Faq />
  },
  {
    path: '/pages/knowledge-base',
    element: <KnowledgeBase />
  },
  {
    path: '/pages/knowledge-base/:category',
    element: <KnowledgeBaseCategory />
  },
  {
    path: '/pages/knowledge-base/:category/:question',
    element: <KBCategoryQuestion />
  },
  {
    path: '/my-profile/account-settings',
    element: <AccountSettings />
  },
  {
    path: '/my-profile/daily-planning',
    element: <ClockInOut />
  },
  {
    path: '/my-profile/my-time-sheet',
    element: <MyTimeSheet />
  },
  {
    path: '/my-profile/resource-planning',
    element: <ResourcePlanning />
  },
  {
    path: '/my-profile/book-time-off',
    element: <BookTimeOff />
  },
  {
    path: '/my-profile/zendesk-tickets',
    element: <ZendeskTickets />
  },

  {
    path: '/pages/license',
    element: <License />
  },
  {
    path: '/pages/api-key',
    element: <ApiKey />
  },
  {
    path: '/pages/modal-examples',
    element: <ModalExamples />
  },
  {
    path: '/pages/wiki/list',
    element: <WikiList />
  },
  {
    path: '/pages/wiki/detail/:id',
    element: <WikiDetails />
  },
  {
    path: '/pages/wiki/detail',
    element: <Navigate to='/pages/wiki/detail/1' />
  },
  {
    path: '/pages/wiki/edit/:id',
    element: <WikiEdit />
  },
  {
    path: '/pages/wiki/edit',
    element: <Navigate to='/pages/wiki/edit/1' />
  },
  {
    path: '/pages/pricing',
    element: <Pricing />
  },
  {
    path: '/misc/coming-soon',
    element: <ComingSoon />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/not-authorized',
    element: <NotAuthorized />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/maintenance',
    element: <Maintenance />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/error',
    element: <Error />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/switch',
    element: <SystemSwitch />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  }
]

export default PagesRoutes
